/**
 * Traduções específicas para mensagens comuns (não ligadas a regra de negócio).
 */
export default {
  actions: {
    viewRawData: 'Visualizar dados',
    clearFilters: 'Limpar filtros',
  },
}
